import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { useMenu as u } from "./useMenu.js";
import { MenuProvider as c } from "./useMenuContext.js";
import { MenuDescendantsProvider as d } from "./useMenuDescendantsContext.js";
import { MenuButton as p } from "./MenuButton/MenuButton.js";
const x = ({ children: r, menuButton: n, closeOnSelect: o, onClose: t }) => {
  const { descendants: i, ...m } = u({ closeOnSelect: o, onClose: t });
  return /* @__PURE__ */ e(d, { value: i, children: /* @__PURE__ */ s(c, { value: m, children: [
    /* @__PURE__ */ e(p, { children: n }),
    r
  ] }) });
};
export {
  x as Menu
};
//# sourceMappingURL=Menu.js.map
